const translations = { required: 'Campo obrigatório', invalidEmail: 'Email inválido' }

export default translations
